/* eslint-disable lingui/no-unlocalized-strings, lingui/text-restrictions -- Practice notebook copy; localised together with the rest of the practice area. */
import { RotateCcw } from "lucide-react";
import { useEffect } from "react";
import { Link, useRouteError } from "react-router-dom";

import { NotebookPage, PRACTICE_HOME } from "./ui";

/** Shown instead of React Router's developer screen when a Practice page throws. */
export const PracticeRouteError = () => {
  const error = useRouteError();

  useEffect(() => {
    console.error("Practice Interview page error", error);
  }, [error]);

  return (
    <NotebookPage tabs={false}>
      <div role="alert" style={{ display: "grid", gap: 10, maxWidth: 560 }}>
        <p className="pn-eyebrow">Practice Interview</p>
        <h1 className="pn-h1">This page hit a snag</h1>
        <p className="pn-muted">
          Your answers and recording are saved. Reload to try again, or head back to Practice.
        </p>
        <div className="pn-next" style={{ marginTop: 8 }}>
          <button
            type="button"
            className="pn-btn pn-btn-primary"
            onClick={() => window.location.reload()}
          >
            <RotateCcw aria-hidden />
            Reload
          </button>
          <Link className="pn-btn pn-btn-quiet" to={PRACTICE_HOME}>
            Back to Practice
          </Link>
        </div>
      </div>
    </NotebookPage>
  );
};
